module.exports = __webpack_public_path__ + "static/media/cnn.com_election_results_president_plot.4a2489e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/cnn.com_election_results_president_plot.png
// module id = 383
// module chunks = 0